
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SortingItemsDialog extends Common.GridEditorDialog<SortingItemsRow> {
        protected getFormKey() { return SortingItemsForm.formKey; }
        //protected getIdProperty() { return SortingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return SortingItemsRow.localTextPrefix; }
        //protected getNameProperty() { return SortingItemsRow.nameProperty; }
        //protected getService() { return SortingItemsService.baseUrl; }
        protected getDeletePermission() { return SortingItemsRow.deletePermission; }
        protected getInsertPermission() { return SortingItemsRow.insertPermission; }
        protected getUpdatePermission() { return SortingItemsRow.updatePermission; }

        protected form = new SortingItemsForm(this.idPrefix);
        constructor() {
            super();
            //Make grid full width
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.ImageName);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.GrossAmount);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            //Cascade Code
           

            if (this.entity.HasBom == false) {
                q.hideEditorTab(this.form.ImageName);
                
            }
        }
    }
}